@if (isSaving()) {
  <span class="align-middle">
    <span
      class="spinner-border spinner-border-sm me-1"
      role="status"
      aria-hidden="true"
    ></span
    >Sparar...
  </span>
} @else {
  <lib-icon
    name="cloud"
    size="x-small"
    aria-hidden="true"
    class="me-1"
  ></lib-icon
  >Sparad
  {{ lastModified() | date: dateFormat() }}
}
